var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-selector"},_vm._l((_vm.options),function(option){return _c('button',{key:option.value,staticClass:"btn",class:{
      'btn-outline': option.value !== _vm.selected,
    },on:{"click":function($event){return _vm.handleSelected(option.value)}}},[_c('p',[_vm._v(_vm._s(option.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }